<template>
  <div
    v-if="!blackList.includes(Number(exhibitionId))"
    class="tag-container">
    <template v-for="(item, idx) in tag.smallList">
      <!-- <span
        v-if="idx < tagNum && smallTag"
        :key="item"
        :class="{ follow: true, white: theme === 'black' }"
        :title="`${exhibitionName}${item}`"
        @click="getTagUrl(item)">
        {{ item }}
      </span> -->
      <a
        v-if="idx < tagNum && smallTag"
        :key="item"
        :class="{ follow: true, white: theme === 'black' }"
        :title="`${exhibitionName}${item}`"
        target="_blank"
        :href="getTagUrlHref(item)">
        {{ item }}
      </a>
    </template>
    <template v-for="(item, idx) in tag.list">
      <!-- <span
        v-if="idx < tagNum && !smallTag"
        :key="item"
        :class="{ follow: true, white: theme === 'black' }"
        :title="`${exhibitionName}${item}`"
        @click="getTagUrl(item)">
        {{ item }}
      </span> -->
      <a
        v-if="idx < tagNum && !smallTag"
        :key="item"
        :class="{ follow: true, white: theme === 'black' }"
        :title="`${exhibitionName}${item}`"
        target="_blank"
        :href="getTagUrlHref(item)">
        {{ item }}
      </a>
    </template>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import { blackList } from '~/utils/constant'

  const props = defineProps({
    exhibitionId: {
      type: [String, Number],
      default: ''
    },
    exhibitionName: {
      type: String,
      default: ''
    },
    isNoTicket: {
      type: Number,
      default: 0
    },
    smallTag: {
      type: Boolean,
      default: false
    },
    tagNum: {
      type: Number,
      default: 3
    },
    theme: {
      type: String,
      default: 'white'
    },
    thirdUrl: {
      type: String,
      default: null
    },
    industryId: {
      type: Number,
      default: 0
    }
  })

  const token = useCookie<string>('access_token')
  const { t: $t } = useI18n()

  const tag = ref({
    list: [$t('common.boothInquiry'), $t('common.ticketBooking'), $t('common.exhibitorECatalog')],
    smallList: [$t('common.booth'), $t('common.ticket'), $t('common.catalog')]
  })

  const getTagUrlHref = (tag: string) => {
    const exhibitionId = props.exhibitionId
    let url = ''
    // 展位咨询 || 展位
    if (tag === $t('common.boothInquiry') || tag === $t('common.booth')) {
      url = `/exhibition/apply/${exhibitionId}.html`

      return url
    } else if (tag === $t('common.ticketBooking') || tag === $t('common.ticket')) {
      // 门票预定 || 门票
      if (props.thirdUrl) {
        if (!token) {
          // Show login modal
        } else {
          return props.thirdUrl
        }
      } else {
        return `/ticket/${exhibitionId}.html`
      }
    } else if (tag === $t('common.exhibitorECatalog') || tag === $t('common.catalog')) {
      // 展商/电子会刊查看 || 会刊
      return `/periodical/${exhibitionId}.html`
    }
  }

  const getTagUrl = (tag: string) => {
    const exhibitionId = props.exhibitionId
    let url = ''
    // 展位咨询 || 展位
    if (tag === $t('common.boothInquiry') || tag === $t('common.booth')) {
      url = `/exhibition/apply/${exhibitionId}.html`
      window.open(url, '_blank')
    } else if (tag === $t('common.ticketBooking') || tag === $t('common.ticket')) {
      // 门票预定 || 门票
      if (props.thirdUrl) {
        if (!token) {
          // Show login modal
        } else {
          url = props.thirdUrl
          window.open(url, '_blank')
        }
      } else {
        url = `/ticket/${exhibitionId}.html`
        window.open(url, '_blank')
      }
    } else if (tag === $t('common.exhibitorECatalog') || tag === $t('common.catalog')) {
      // 展商/电子会刊查看 || 会刊
      url = `/periodical/${exhibitionId}.html`
      window.open(url, '_blank')
    }
  }
</script>

<style lang="less" scoped>
  .tag-container {
    display: flex;
    align-items: center;

    .follow {
      font-size: 12px;
      color: #333;
      padding: 3px 6px;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #cdcfd6;
      margin-right: 8px;
      cursor: pointer;
      transition: all 0.3s;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        color: @app-color;
        border: 1px solid @app-color;
      }
    }

    .white {
      background: transparent;
      color: #fff;
    }
  }
</style>
